import React from 'react';
import {useTranslations, createTranslator} from 'next-intl';
import {Grid, Row, Col} from '@/grid';
import withMainLayout from 'layouts/main';
import {SectionPadding, SectionPaddingTopAd} from '@/section';
import Container from '@/container';
import {withBgLegalPages} from '@/hocs/withColors';
import {H1Neutral50, H2} from '@/typography';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import boxGridStyles from '@/ui/box-grid/box-grid.module.scss';
import Link from '@/links';
import {withMarginBottomXlToSm} from '@/hocs/withSpacing';
import {pageMessagesProps} from 'helpers/i18n';
import styles from './legal.module.scss';
import shared from '../../messages/en/shared.json';
import legalIndex from '../../messages/en/legalIndex.json';

const seoMetas = props => {
  const seoT = createTranslator({locale: props.locale, messages: props.messages});
  return {
    title: seoT('legalIndex.seo.title'),
    description: seoT('legalIndex.seo.description'),
    canonical: seoT('legalIndex.seo.canonical')
  };
};

const SectionTitle = withBgLegalPages(SectionPadding);
const DivMargined = withMarginBottomXlToSm('div');
const fullWidth = boxGridStyles['full-width'];

const LegalPage = () => {
  const t = useTranslations('legalIndex');
  const termsOfUse = t.raw('groups.termsOfUse.links');
  const dataProtection = t.raw('groups.dataProtection.links');
  const additionalTerms = t.raw('groups.additionalTerms.links');
  const privacyNotice = t.raw('groups.privacyNotice.links');
  const compliance = t.raw('groups.compliance.links');

  return (
    <>
      <SectionPaddingTopAd>
        <SectionTitle>
          <Container>
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <H1Neutral50>{t('heading')}</H1Neutral50>
                </Col>
              </Row>
            </Grid>
          </Container>
        </SectionTitle>
      </SectionPaddingTopAd>
      <Container>
        <SectionPadding>
          <Grid fluid>
            <Row className={styles['legal-content']}>
              <Col xs={12}>
                <DivMargined>
                  <GridLayout Col={3} lgCol={1} autoRows>
                    <GridItem Col={1}>
                      <BoxGrid backgroundColor="var(--yellow50)" minHeight={200} className={fullWidth}>
                        <H2 className="heading-3">{t('groups.termsOfUse.heading')}</H2>
                        <ul>
                          {termsOfUse.map((item, index) => (
                            <li key={index}>
                              <Link href={item.url} variant="green800">
                                {item.linkCopy}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </BoxGrid>
                    </GridItem>
                    <GridItem Col={1}>
                      <BoxGrid backgroundColor="var(--yellow50)" minHeight={200} className={fullWidth}>
                        <H2 className="heading-3">{t('groups.dataProtection.heading')}</H2>
                        <ul>
                          {dataProtection.map((item, index) => (
                            <li key={index}>
                              <Link href={item.url} variant="green800">
                                {item.linkCopy}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </BoxGrid>
                    </GridItem>
                    <GridItem Col={1}>
                      <BoxGrid backgroundColor="var(--yellow50)" minHeight={200} className={fullWidth}>
                        <H2 className="heading-3">{t('groups.additionalTerms.heading')}</H2>
                        <ul>
                          {additionalTerms.map((item, index) => (
                            <li key={index}>
                              <Link href={item.url} variant="green800">
                                {item.linkCopy}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </BoxGrid>
                    </GridItem>
                  </GridLayout>
                </DivMargined>
                <GridLayout Col={2} lgCol={1} autoRows>
                  <GridItem Col={1}>
                    <BoxGrid backgroundColor="var(--yellow50)" minHeight={200} className={fullWidth}>
                      <H2 className="heading-3">{t('groups.privacyNotice.heading')}</H2>
                      <ul>
                        {privacyNotice.map((item, index) => (
                          <li key={index}>
                            <Link href={item.url} variant="green800">
                              {item.linkCopy}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </BoxGrid>
                  </GridItem>
                  <GridItem Col={1}>
                    <BoxGrid backgroundColor="var(--yellow50)" minHeight={200} className={fullWidth}>
                      <H2 className="heading-3">{t('groups.compliance.heading')}</H2>
                      <ul>
                        {compliance.map((item, index) => (
                          <li key={index}>
                            <Link href={item.url} variant="green800">
                              {item.linkCopy}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </BoxGrid>
                  </GridItem>
                </GridLayout>
              </Col>
            </Row>
          </Grid>
        </SectionPadding>
      </Container>
    </>
  );
};

export default withMainLayout(LegalPage, seoMetas);

export const messagesForIntl = {shared, legalIndex};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}
